import React from 'react';
import {Container, Row, Col} from 'react-bootstrap'
import Jumbotron from 'react-bootstrap/Jumbotron'
import Image from 'react-bootstrap/Image'
import JumboIMG from './assets/jumboIMG.png'
import MultipleTableCuppings from './tables/MultipleTableCuppings'
import TableCuppingsCard from './tables/TableCuppingsCard'

const Home = props => {
    const renderChecks = () =>{
    
        if (props.name && props.userTables) {
            const latestTable = props.userTables[0]

            return (
                <React.Fragment>
                    <Container className="w3-container">
                        <p className="w3-center w3-animate-fading animate"><i>Hola {props.name}!</i></p>
                        <h5 className="styleHeading"><span style={{color: "rgba(251, 77, 61, 1)"}}> My Latest</span> Cupping</h5>
                        {latestTable ? <TableCuppingsCard key={latestTable.id} table={latestTable} isLoggedIn={props.isLoggedIn}/> : <p className="w3-center"><i>You haven't created any cupping tables yet :(</i></p> }
                        <h5 className="styleHeading"> Latest <span style={{color: "rgba(251, 77, 61, 1)"}}> Public Cuppings </span> </h5>
                        <MultipleTableCuppings tableCuppings={props.latestCuppings} isLoggedIn={props.isLoggedIn} /> 
                    </Container>
                </React.Fragment>
            )
        } else {
            return (
                <React.Fragment>
                <Container>
                    <Jumbotron  style={{padding: "0.5rem 0.5rem"}} >
                        <Row className="justify-content-md-center">
                        <Col md="auto">
                            <Image src={JumboIMG} fluid />
                        </Col> <br></br>
                        <Col md="auto"></Col>
                        </Row>
                        <Row className="justify-content-md-center">
                         <Col md="auto"> <small> {!props.isLoggedIn ? `Please Login to access all Catoro features.`: "Welcome to Catoro!"} </small></Col> 
                        </Row>
                    </Jumbotron>
                    <h5 className="styleHeading"> Latest Public Cuppings </h5>
                    <MultipleTableCuppings tableCuppings={props.latestCuppings} isLoggedIn={props.isLoggedIn}/>
                </Container>
                </React.Fragment>
             )
        }
    }

    return renderChecks()
}

export default Home